import { render, staticRenderFns } from "./MoonBoard.vue?vue&type=template&id=5dd8ddbe&"
import script from "./MoonBoard.vue?vue&type=script&lang=ts&"
export * from "./MoonBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports